module.exports = __webpack_public_path__ + "assets/smart-slider-3.cd759bec.svg";